// extracted by mini-css-extract-plugin
export default {"infoBox":"join-organization-auth_infoBox__S4cwS"};